import { combineReducers } from 'redux'
import operationReducer from './reducers/operationReducer'
import resultReducer from './reducers/resultReducer'
import equationReducer from './reducers/equationReducer'

const reducers = combineReducers({
  operation: operationReducer,
  equation: equationReducer,
  result: resultReducer
})

export default reducers